import LegalPageShell, { H2, P, UL } from "../../components/LegalPageShell";

export default function TermsOfService() {
  return (
    <LegalPageShell
      eyebrow="LEGAL · TERMS OF SERVICE"
      title="Terms of Service"
      lastUpdated="February 2026"
      testId="terms-page"
    >
      <P>
        Welcome to Wanted. These Terms of Service ("Terms") form a binding agreement between you and
        Wanted ("we," "us," "our") when you create an account, browse profiles, send messages, or
        otherwise use the Wanted website, mobile experience, and services (collectively, the "Service").
        By creating an account or using the Service, you agree to these Terms.
      </P>

      <H2>1. Eligibility</H2>
      <P>
        You must be at least 18 years old and able to form a binding contract in your country of residence
        to use Wanted. You may not use the Service if you have previously been removed from it, are required
        to register as a sex offender in any jurisdiction, or are barred from receiving the Service under
        applicable law.
      </P>

      <H2>2. Your Account</H2>
      <UL>
        <li>You agree to provide accurate, truthful information when you create your profile.</li>
        <li>You are responsible for safeguarding your password and any activity on your account.</li>
        <li>You may only create one personal account. Accounts are non-transferable.</li>
        <li>You agree to keep your account information up to date.</li>
      </UL>

      <H2>3. Your Profile, Photos, and Messages</H2>
      <P>
        You retain ownership of the photos, text, and other content you submit ("Your Content"). By submitting
        Your Content, you grant Wanted a worldwide, non-exclusive, royalty-free license to host, store,
        reproduce, modify (for formatting), and display Your Content solely for the purpose of operating
        and improving the Service.
      </P>
      <P>
        You represent that you own or have the rights to any content you submit and that it does not violate
        the rights of any third party.
      </P>

      <H2>4. Acceptable Use</H2>
      <P>You agree not to:</P>
      <UL>
        <li>Impersonate any person or entity, or misrepresent your identity or affiliation.</li>
        <li>Post or transmit content that is harassing, defamatory, hateful, sexually explicit, or unlawful.</li>
        <li>Use the Service for commercial solicitation, advertising, escort services, or sex work.</li>
        <li>Use bots, scrapers, automated tools, or any unauthorized means to access the Service.</li>
        <li>Attempt to gain unauthorized access to other accounts, our systems, or our data.</li>
        <li>Share another member's personal information, photos, or messages without their consent.</li>
      </UL>
      <P>
        Detailed expectations are set out in our{" "}
        <a href="/community-guidelines" className="text-gold hover:text-gold-soft">Community Guidelines</a>,
        which are incorporated into these Terms.
      </P>

      <H2>5. Verification</H2>
      <P>
        Wanted takes steps to confirm that members are real people. We may, from time to time, ask you to
        complete a photo verification or other identity check. Verification helps keep the community real,
        but it is not a background check and does not guarantee the character or conduct of any member.
      </P>

      <H2>6. Memberships and Payments</H2>
      <P>
        Some features require a paid membership ("Premium"). Premium is offered as a recurring monthly
        subscription. By starting a Premium membership, you authorize us (through our payment processor,
        Stripe) to charge the applicable fee to your payment method on a recurring basis until you cancel.
      </P>
      <P>
        Cancellation, refund, and renewal terms are described in our{" "}
        <a href="/refunds" className="text-gold hover:text-gold-soft">Refund &amp; Cancellation Policy</a>.
      </P>

      <H2>7. Suspension and Termination</H2>
      <P>
        We may suspend or terminate your account at any time, with or without notice, if you violate these
        Terms, our Community Guidelines, or applicable law, or if your behavior threatens the safety of
        other members. You may terminate your account at any time from your profile settings or by contacting us.
      </P>

      <H2>8. Disclaimers</H2>
      <P>
        Wanted is provided "as is" and "as available." We make no warranties, express or implied, regarding
        the Service. We do not guarantee that you will meet, match with, or form a connection with any
        particular member. Use of the Service is at your sole risk.
      </P>

      <H2>9. Limitation of Liability</H2>
      <P>
        To the maximum extent permitted by law, Wanted and its affiliates will not be liable for any
        indirect, incidental, special, consequential, or punitive damages, or any loss of profits,
        revenue, data, or goodwill arising out of your use of the Service.
      </P>

      <H2>10. Indemnification</H2>
      <P>
        You agree to indemnify and hold Wanted and its affiliates harmless from any claims, damages, or
        expenses (including reasonable attorneys' fees) arising out of your use of the Service or your
        violation of these Terms.
      </P>

      <H2>11. Changes to These Terms</H2>
      <P>
        We may update these Terms from time to time. If changes are material, we will let you know by
        posting a notice on the Service or via email. Your continued use of the Service after changes
        take effect constitutes your acceptance of the updated Terms.
      </P>

      <H2>12. Governing Law</H2>
      <P>
        These Terms are governed by the laws of the jurisdiction in which Wanted operates, without regard
        to its conflict of laws principles. You agree to submit to the personal and exclusive jurisdiction
        of the courts located therein for the resolution of any disputes.
      </P>

      <H2>13. Contact</H2>
      <P>
        For any questions about these Terms, please email{" "}
        <a href="mailto:hello@joinwanted.com" className="text-gold hover:text-gold-soft">
          hello@joinwanted.com
        </a>.
      </P>
    </LegalPageShell>
  );
}
